<template>
    <div>
        <TitleImage image="home" title="Nuestra Escuela" />
        <div class="col-md-9 col-sm-12 container">
            <div class="spacer"></div>
            <div :class="{'min-vh-100': school.description == undefined}" v-html="school.description">
            
            </div>
            
            <div class="text-center">
                <div class="spacer"></div>
                <h3>Nuestro equipo</h3>
                <hr>
                <div class="row"> 
                    <div class="col-6 col-md-4 p-1" v-for="(member, i) in team" :key="i">          
                        <div class="text-center py-3">
                            <img :src="member.image" class="mx-auto rounded-circle teamImage" width="120" height="120">
                            <h4 class="card-title mt-3 mb-2">{{member.name}}</h4>
                            <p class="card-text">{{member.description}}</p>          
                        </div>
                    </div>               
                </div>
            </div>

            <Techniques />
            <div class="spacer"></div>
        </div>
        <Contact />

    </div>
</template>

<script>
import TitleImage from '@/components/TitleImage'
import Techniques from '@/components/Techniques'
import Contact from '@/components/Contact'
import {db} from '../firebase'

export default {
    name: 'School',
    async created(){
        this.school = await this.$store.dispatch('school/getSchool')
        const team = await db.collection('team').doc('data').get()
        this.team = team.data().team
    },
    data(){
        return {
            school: {},
            team: []
        }
    },
    components:{
        TitleImage,
        Techniques,
        Contact
    }
}
</script>

<style scoped>
.teamImage{
    object-fit: cover;
}
</style>